var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContinuousImprovment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 269.9,
    height: 187.417,
    viewBox: "0 0 269.9 187.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.869 -1753.2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.308 1787.359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M693.381,307.13c.551,1.837-1.9,13.35-1.9,13.35s-1.286,2.833-1.04,3.1-.919,2.778-3.491,2.532-6.615-1.1-8.636-.735c-1.51.276-5.832-.956-7.853-2.076-.687-.367-1.1-.753-1.066-1.047.158-1.161,4.016-6.431,4.016-6.431a10.791,10.791,0,0,0,1.764.316c.162,0,.279-.018.32-.07.184-.246,4.472,1.286,5.145,1.716a6.2,6.2,0,0,0,2.51.349,15.5,15.5,0,0,1,2.513-4.086,6.2,6.2,0,0,0,1.415-3.109,24.215,24.215,0,0,1,.639-2.686c.367-1.227.7-2.818.272-3.392-.735-.981-7.963-11.88-1.716-11.7s7.412,8.819,7.412,8.819S692.83,305.293,693.381,307.13Z",
    transform: "translate(-614.378 -266.914)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.332,334.833l-5.145,2.2-5.972,1.837s-13.688-11.116-10.2-11.943a5.974,5.974,0,0,0,1.72-.735,13.577,13.577,0,0,0,2.767-2.385,24.359,24.359,0,0,0,2.4-3.112s13.5-.643,11.392,2.572c-.823,1.253-.544,3.289.1,5.306.037.121.077.243.118.367a33.986,33.986,0,0,0,2.811,5.887Z",
    transform: "translate(-569.503 -284.299)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.9,526.4s-2.37-2.2-3.234,1.191a34.9,34.9,0,0,0-1.022,5.567,40.1,40.1,0,0,1-2,5.1c-.691,1.1-3.348,11.318,1.727,10.289,0,0,1.867-.4,2.231-4.707s3.5-17.168,3.5-17.168Z",
    transform: "translate(-535.904 -413.997)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.316,512.181c-5.145,1.926-11.3,1.43-14.548.956-1.4-.2-2.264-.4-2.264-.4l-16.077-1.654-.323.338-2.065,2.15-2.389,5.78s-6.431,8.819-7.166,3.583a21.544,21.544,0,0,1-.136-3.454,95.37,95.37,0,0,1,1.606-12.99l14.607-1.929,9.187-4.777.1-4.983.022-1.224.062-3.072,12.494,1.194,2.2,4.961.022.022c.323.3,4.439,4.163,5.674,5.4S600.666,509.425,593.316,512.181Z",
    transform: "translate(-537.801 -391.735)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.774,552.84s-6.559.276-6.982-.9l-2.032,4.847s5.971,2.3,6.8,1.422Z",
    transform: "translate(-538.706 -430.597)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.583,512.8s-4.27-2.113-4.821,1.929a29.8,29.8,0,0,0-.276,6.57s-1.1,4.821-1.929,6.2-2.572,13.567,5.189,11.484c0,0,2.848-.779,2.388-5.788s1.411-20.3,1.411-20.3Z",
    transform: "translate(-521.013 -405.491)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.5,510.717a14.569,14.569,0,0,1-2.33.68,25.79,25.79,0,0,1-8.143.423,57.356,57.356,0,0,1-10.521-2.142c-.676-.206-1.054-.338-1.054-.338s-4.777-.735-6.431,1.837c-1.1,1.694-3.054,4.7-4.27,6.559l-1.058,1.617s-4.5,8.911-7.441-2.113l3.767-10.749a34.642,34.642,0,0,0,0-4.41c-.125-.562,1.062-2.433,2.267-3.2.57-.368,1.147-.492,1.591-.107a18.086,18.086,0,0,0,2.94,2.238,3.52,3.52,0,0,0,1.837.518c1.562-.092,5.512-.184,5.512-.184l-2.3-.827a35.962,35.962,0,0,1-3.675-1.268c-1.43-.6-2.679-1.323-2.469-1.948.459-1.378,3.674-8.084,3.674-8.084l16.261-1.47,4.623,4.083,1.981,1.745,6.718,5.931S575.686,503.643,566.5,510.717Z",
    transform: "translate(-523.203 -389.995)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.914,537.63l-2.664,6.107s2.94,6.754,8.636,5.744l3.5-6.346S530.48,542.312,528.914,537.63Z",
    transform: "translate(-523.835 -421.545)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.27,344.98c-1.194.276-6.615,3.4-6.615,3.4l-3.4,5.88s.092,3.307,0,5.512-2.664,1.929-2.664,1.929l-.125.051c-.658.276-3.745,1.573-3.745,1.6s-6.328-.643-6.328-.643l-12.4-2.021s-3.951-.184-5.237-1.47l-.037-.037c-1.242-1.268-.772-2.183,1.231-3.73s.459-3.95.459-3.95a31.269,31.269,0,0,1-1.1-6.339c0-2.389-1.194-2.3-1.194-2.3s-.827,0,2.848-2.389-.459-13.5.827-11.943,3.675.735,3.858-.184,3.951,1.194,3.951,1.194,1.654-1.011,2.2,0a1.2,1.2,0,0,0,1.47.643c.919,3.032,7.717,6.982,7.717,6.982,6.063,2.2,11.3-4.869,11.3-4.869s2.021.551,2.3,1.385,2.572.794,2.572.794,2.756.3,2.848,1.128,2.756,1.929,2.756,1.929A6.239,6.239,0,0,1,602.27,344.98Z",
    transform: "translate(-545.836 -289.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.728,411.75s19.844,1.1,22.6,2.389l3.215.459-.551,3.491s5.236,5.42,6.8,6.063.827,22.691.827,22.691-3.859-5.971-8.911-3.032-8.636-1.654-8.636-1.654-8.819,1.837-11.851,4.318-5.512-.735-5.512-.735-1.01,4.41-2.2,4.869-1.47,3.4-1.47,3.4-3.307-.643-3.307-1.654a2.521,2.521,0,0,0-.735-2.113c-.643-.735-.735-3.124-.735-3.124s.367-2.756-.827-3.858-1.1-5.788-1.1-5.788-.555-3.032,0-3.767.919-5.7.919-5.7,1.838-5.145,2.848-7.074,5.88-5.236,5.88-5.236h.54l.184-3.583Z",
    transform: "translate(-528.787 -341.923)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.57,424h.735s-4.409,10.106-4.652,7.287S558.57,424,558.57,424Z",
    transform: "translate(-541.794 -349.671)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.082,426s-5.024,7.717-2.572,8.819,4.652-8.452,4.652-8.452Z",
    transform: "translate(-552.037 -350.937)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.83,438.12s1.9,11.715,4.042,13.982a2.365,2.365,0,0,1-.368,3.859s7.533.672,9.922,1.161,6.063-.551,4.593-1.529-.243-11.392-.121-11.884S611.184,452.742,597.83,438.12Z",
    transform: "translate(-569.111 -358.603)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.67,385.027c.426-.184,7.287-9.819,8.941-9.044S575.67,385.027,575.67,385.027Z",
    transform: "translate(-555.094 -319.272)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.33,357.67s7.779,1.9,8.393,2.33S638.984,360.426,637.33,357.67Z",
    transform: "translate(-594.096 -307.716)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.95,366.236s-.977-3.8-2.264-3.737S710.95,366.236,710.95,366.236Z",
    transform: "translate(-639.054 -310.77)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.248,290.953c-.478.989-1.518,1.779-1.5,2.877a7.729,7.729,0,0,0,.368,1.518,3.066,3.066,0,0,1-.735,2.469,5.266,5.266,0,0,1-2.179,1.47,2.709,2.709,0,0,0-1.308.783c-.481.694-.062,1.621.136,2.444.316,1.327-.206,2.984-1.5,3.4-.695.22-1.525.07-2.1.514s-.632,1.334-.988,2a2.286,2.286,0,0,1-2.991.9,2.314,2.314,0,0,1,.129-1,1.882,1.882,0,0,1-2.1-.856,2.506,2.506,0,0,1,.018-2.2,8.257,8.257,0,0,1,1.316-1.881,27.723,27.723,0,0,0,3.991-6.137,15.972,15.972,0,0,0,1.54-7.114,5.442,5.442,0,0,0-.415-2.124,5.271,5.271,0,0,0-1.448-1.756c-.3-.265-.628-.514-.944-.768-.22-.176-.441-.367-.65-.536-.287-.254-1.426-1.183-1.334-1.632.051-.257.823-.22,1.5-.228a3.654,3.654,0,0,0,.735-.059.743.743,0,0,0,.151-.044,5.776,5.776,0,0,1,.694-.342,2.3,2.3,0,0,1,1.958.65,24.341,24.341,0,0,0,2.572,1.863,5.027,5.027,0,0,0,3.032.735,2.745,2.745,0,0,1,1.021-.044c.651.173.937.919,1.1,1.573A5.434,5.434,0,0,1,680.248,290.953Z",
    transform: "translate(-611.743 -260.218)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.9,243.106a3.788,3.788,0,0,0-.419.074,6.768,6.768,0,0,0-1.132.43,16.557,16.557,0,0,0-1.838,1.1l-4.527,2.962a3.729,3.729,0,0,0-1.1.948c-.768,1.128-.048,2.741,1.066,3.535.515.367,1.1.625,1.606,1a2.205,2.205,0,0,1,.985,1.543c.055.959-.827,1.712-1.712,2.076a12.143,12.143,0,0,0-2.653,1.069,1.529,1.529,0,0,1-.529.3,1.162,1.162,0,0,1-.669-.129,27.77,27.77,0,0,1-4-2.062.541.541,0,0,1,.165.577,7.981,7.981,0,0,1-4.56-11.63,23.217,23.217,0,0,0,1.47-2.4,2.944,2.944,0,0,0,0-2.7c-.368-.548-1.01-.915-1.2-1.543a2.132,2.132,0,0,1,.687-1.892c1.062-1.1,2.528-1.764,3.7-2.771s2.058-2.675,1.393-4.068c-.529-1.1-1.951-1.922-1.712-3.124a2.128,2.128,0,0,1,1.018-1.268,6.052,6.052,0,0,1,5.88-.367,1.356,1.356,0,0,1,.577-1.47,1.319,1.319,0,0,1,1.565.18,6.763,6.763,0,0,0,.522.592.5.5,0,0,0,.7-.029.69.69,0,0,0,.077-.367,4.615,4.615,0,0,1,.507-1.944,14.776,14.776,0,0,1,1.738,13.343,5.266,5.266,0,0,0-.489,1.929c.041,1.385,1.338,2.414,2.638,2.885l.07.022c.408.132,1.1.246,1.779.434.889.246,1.746.621,1.837,1.323C576.535,242.808,574.058,242.948,572.9,243.106Z",
    transform: "translate(-540.441 -221.73)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.209,257.8c-.672.735-4.163,9-4.163,9,.29,2.025,6.46,4.432,9.073,5.361.705.254,1.154.4,1.154.4l2.51,2.2s-2.572,14.21-2.778,10.719-4.755-5.27-4.755-5.27-1.191-.485-2.616-1.143c-2-.915-4.469-2.157-4.777-2.837-.551-1.165-1.286-1.532-5.086-4.961s-1.286-6.247-1.161-6.615c.61-1.837,6.736-9.948,6.736-9.948l8.867-10.815s2.447-10.043,8.6-6.126-7.008,13.292-7.008,13.292S533.882,257.061,533.209,257.8Z",
    transform: "translate(-519.678 -231.302)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.494,331.7,563.8,329.25s-17.426,5.512-5.667,15.956h4.957l4.542-6.034Z",
    transform: "translate(-541.425 -289.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.948,284.5a13.178,13.178,0,1,1-3.86-9.37A13.229,13.229,0,0,1,631.948,284.5Z",
    transform: "translate(-573.957 -253.065)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.748,275.734a12.962,12.962,0,0,0,.143,2.109,2.308,2.308,0,0,0,2.877,1.47,6.226,6.226,0,0,0,2.179-1.951,13.508,13.508,0,0,1,3.307-2.473,6.112,6.112,0,0,1,1.933-.812,5.165,5.165,0,0,1,3.616.985c1.077.694,2.028,1.569,3.146,2.2a4.368,4.368,0,0,0,3.675.5l.412,2.44a1.473,1.473,0,0,0,.268.735,1.334,1.334,0,0,0,.8.367,5.949,5.949,0,0,0,2.738-.158,1.573,1.573,0,0,0,1.073-.764,1.718,1.718,0,0,0,.11-.581,31.864,31.864,0,0,0-2.124-13.773,9.638,9.638,0,0,0-2.782-4.241,11.231,11.231,0,0,0-2.572-1.36c-2.749-1.165-5.776-2.352-8.647-1.518a13.01,13.01,0,0,0-3.487,1.837l-5.145,3.414a3.214,3.214,0,0,0-.735.606,3.513,3.513,0,0,0-.555,1.213,23.512,23.512,0,0,1-2.109,4.733,2.347,2.347,0,0,0-.4.981,2.239,2.239,0,0,0,.213.944c.264.687.367,1.2.97,1.6A1.894,1.894,0,0,1,603.748,275.734Z",
    transform: "translate(-571.413 -245.076)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.869 1753.2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.48,
    height: 8.424,
    transform: "translate(11.682 52.741)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.48,
    height: 8.424,
    transform: "translate(146.41 163.01)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.48,
    height: 8.424,
    transform: "translate(243.982 82.335) rotate(90)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.597,
    cy: 25.597,
    r: 25.597,
    transform: "translate(196.694 119.192)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.475,602.344l7.652-1.385-2.482-15.978-7.652,1.385Z",
    transform: "translate(-642.297 -422.503)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.776,
    height: 13.932,
    transform: "translate(224.526 178.956) rotate(169.739)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.48,
    cy: 2.43,
    rx: 6.48,
    ry: 2.43,
    transform: "matrix(0.763, -0.646, 0.646, 0.763, 212.85, 183.708)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.48,
    cy: 2.43,
    rx: 6.48,
    ry: 2.43,
    transform: "matrix(0.763, -0.646, 0.646, 0.763, 227.835, 183.264)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.748,
    cy: 8.748,
    r: 8.748,
    transform: "translate(211.751 132.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.916,
    cy: 2.916,
    r: 2.916,
    transform: "translate(213.988 135.291)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.489,506.376c.385-9.476-7.782-17.5-18.242-17.928S884,495.361,883.611,504.837s6.886,11.629,17.346,12.054S921.1,515.852,921.489,506.376Z",
    transform: "translate(-679.005 -385.541)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.018,
    cy: 12.798,
    rx: 4.018,
    ry: 12.798,
    transform: "matrix(0.223, -0.975, 0.975, 0.223, 188.836, 143.602)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.018,
    cy: 12.798,
    rx: 4.018,
    ry: 12.798,
    transform: "matrix(0.223, -0.975, 0.975, 0.223, 235.529, 151.458)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.552,669.6a5.832,5.832,0,1,1-11.478,2.078c-.574-3.17,1.877-4.291,5.046-4.865S938.979,666.432,939.552,669.6Z",
    transform: "translate(-710.231 -514.726)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 76.234,
    height: 142.679,
    transform: "translate(102.955 15.721)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.765,276.156H514.844v-158.7h94.922Zm-94.328-.593h93.735V118.052H515.437Z",
    transform: "translate(-412.988 -117.459)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 269.9,
    height: 0.665,
    transform: "translate(0 185.574)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.628,242.311H553.844V176.459h71.785Zm-71.191-.593h70.6V177.052h-70.6Z",
    transform: "translate(-440.279 -158.958)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.32,114.983l-.419-.419,22.373-22.373,13.136,13.136,35.534-35.534.42.419L493.41,106.166,480.274,93.03Z",
    transform: "translate(-344.242 -49.09)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.449,
    cy: 4.449,
    r: 4.449,
    transform: "translate(132.691 36.874)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.449,
    cy: 4.449,
    r: 4.449,
    transform: "translate(145.272 48.327)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.449,
    cy: 4.449,
    r: 4.449,
    transform: "translate(178.823 16.315)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.987,
    height: 5.339,
    transform: "translate(122.553 95.925)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.525,431.917H536.608V407h16.908v.593H537.2v23.73h23.73V419.458h.593Z",
    transform: "translate(-399.4 -293.955)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.678,420.967l-5.27-7.027,1.9-1.424,3.629,4.838,16.682-16.682,1.678,1.678Z",
    transform: "translate(-416.534 -289.189)",
    fill: "#c00096"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinuousImprovment);
export default __webpack_public_path__ + "static/media/continuous_improvment.22bea21e2230aea76ad572004067cb3e.svg";
export { ForwardRef as ReactComponent };